
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investors/intro",
      function () {
        return require("private-next-pages/investors/intro.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investors/intro"])
      });
    }
  